export default __webpack_public_path__ + "static/media/Times New Roman Bold.52cae610.ttf";